module.exports = __webpack_public_path__ + "img/dose-graph.d704cf7d.png";